/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `PENDING` - Pending
* `FAILED` - Failed
* `PASSED` - Passed
 */
export type InspectionResult = typeof InspectionResult[keyof typeof InspectionResult];


export const InspectionResult = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  PASSED: 'PASSED',
} as const;
